/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcTradereportingV1Sec606AReportState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_TRADEREPORTING_V1_SEC606_A_REPORT_STATE_ENTITY_NAME = 'ixc.tradereporting.v1.Sec_606AReport';
export const ixcTradereportingV1Sec606AReportStateEntity = new schema.Entity<IxcTradereportingV1Sec606AReportState>(IXC_TRADEREPORTING_V1_SEC606_A_REPORT_STATE_ENTITY_NAME, {}, { idAttribute: 'reportId' });

